<template>
  <div
    id="album"
    class="container"
    v-loading="floading"
    element-loading-background="transparent"
  >
    <section>
      <!-- 廣告 -->
      <div class="section-group">
        <div class="row">
          <div class="col-12">
            <N3Vue></N3Vue>
          </div>
        </div>
      </div>
      <!-- ./廣告 -->

      <!-- 相簿列表 -->
      <div class="album-list section-group">
        <div class="row">
          <div class="col-12">
            <h2 class="section-title">{{$t('Album.albumList.Photoalbumlist')}}</h2>
            <div class="section-subtitle">
              <div class="row">
                <div class="col-12 col-lg-9 py-2">
                  <div class="category">
                    <el-button
                      size="mini"
                      :class="{ current: '' == SGL_PG_CMasterSort }"
                      @click="GetListByType('')"
                      >{{$t('Album.albumList.all')}}</el-button
                    >
                    <el-button
                      size="mini"
                      v-for="item in albumTypeList"
                      :key="item.id"
                      :class="{ current: item.id == SGL_PG_CMasterSort }"
                      @click="GetListByType(item.id)"
                      >{{ item.sgL_NewName }}</el-button
                    >
                  </div>
                </div>
                <div class="col-12 col-lg-3 pt-2">
                  <div class="float-lg-right">
                    <div class="sorting">
                      {{$t('Album.albumList.sorting')}}&nbsp;
                      <!-- <el-button
                        size="mini"
                        @click="orderbyhot('uploadOrder')"
                        :class="{ current: 'uploadOrder' == Sorting }"
                        >按上傳時間</el-button
                      > -->
                      <el-button
                        size="mini"
                        @click="orderbyhot('')"
                        :class="{ current: '' == Sorting }"
                        >{{$t('Album.albumList.orderbyhot')}}{{
                          "" == Sorting
                            ? sortASC === "ascending"
                              ? $t('Album.albumviewPhotoolds.asc')
                              : $t('Album.albumviewPhotoolds.desc')
                            : ""
                        }}</el-button
                      >
                      <el-button
                        size="mini"
                        @click="orderbyhot('QueriesCount')"
                        :class="{ current: 'QueriesCount' == Sorting }"
                        >{{$t('Album.albumList.Bypopularity')}}{{
                          "QueriesCount" == Sorting
                            ? sortASC === "ascending"
                              ? $t('Album.albumviewPhotoolds.asc')
                              : $t('Album.albumviewPhotoolds.desc')
                            : ""
                        }}</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="col-6 col-md-4 col-lg-3 col-xl-2"
                v-for="album in albumList"
                :key="album.id"
              >
                <div class="album-card card">
                  <router-link
                    :to="{
                      name: 'albumviewPhotostream',
                      query: { id: album.id },
                    }"
                  >
                    <div class="album-block clearfix">
                      <div class="album-thumbnail">
                        <div class="album-responsive">
                          <div class="album-sizer">
                            <div
                              class="album-image"
                              :style="{
                                backgroundImage:
                                  'url(' + album.photoImage + ')',
                              }"
                            ></div>
                          </div>
                        </div>
                        <div class="album-photo-count">
                          <span>{{ album.sgL_PG_CPhotoQuantityF }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="album-info p-3">
                      <div class="album-title mb-2" :title="album.sgL_PG_CName">
                        {{ album.sgL_PG_CName }}
                      </div>
                      <span class="album-user">{{
                        album.sgL_Mem_DisplayName
                      }}</span>
                      <span class="album-upload-date">{{
                        album.sgL_PG_CAddTimerI
                      }}</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-5">
        <div class="col-12">
          <!--  引用分页组件 -->
          <pagination
            v-if="getPageShow"
            :currentPage="pageParams.currentPage"
            :total="pageParams.total"
            :limit="pageParams.limit"
            :small="true"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>

      <!-- /.頁碼 -->

      <!-- /.相簿列表 -->
    </section>
  </div>
</template>
<script>
import N3Vue from "../Ad/N3.vue";
import pagination from "../common/Page";

export default {
  data() {
    return {
      sortASC: "descending",
      albumList: null,
      albumTypeList: null,
      SGL_PG_CMasterSort: "",
      Sorting: "",
      floading: true,
      //分页参数
      pageParams: {
        currentPage: 1,
        limit: 50,
        total: 0,
        pageshow: false,
      },
    };
  },
  created() {
    this.urlCheck();
    this.$store.dispatch("updateCurrentIndex", 4);
    this.$store.dispatch("getCommonTypeDesk", 70).then((res) => {
      this.albumTypeList = res; //活動類型
    });
    /* this.SGL_PG_CMasterSort = this.$route.query.id;
    if (this.SGL_PG_CMasterSort == undefined) {
      this.SGL_PG_CMasterSort = "";
    } */
    this.getAlbumList();
  },
  methods: {
    urlCheck() {
      if (this.$route.query.currentPage) {
        this.pageParams.currentPage = Number(this.$route.query.currentPage);
      }
      if (this.$route.query.SGL_PG_CMasterSort) {
        this.SGL_PG_CMasterSort = Number(this.$route.query.SGL_PG_CMasterSort);
      }
      if (this.$route.query.currentSize) {
        this.pageParams.limit = Number(this.$route.query.currentSize);
      }
      if (this.$route.query.Sorting) {
        this.Sorting = this.$route.query.Sorting;
      }
      if (this.$route.query.sortASC) {
        this.sortASC = this.$route.query.sortASC;
      }
    },
    getAlbumList() {
      let params = {
        SGL_PG_CMasterSort: this.SGL_PG_CMasterSort,
        SGL_PG_CPublicshare: true,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        Sorting: this.Sorting, //QueriesCount
        sortASC: this.sortASC,
      };
      this.$api.albumApi.GetalbumHotWeek(params).then((res) => {
        if (res.data.success) {
          this.floading = false;
          this.albumList = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
          if (this.pageParams.total > 1) {
            this.pageParams.pageshow = true;
          }
        }
      });
    },
    orderbyhot(str) {
      if (str === this.Sorting) {
        this.sortASC =
          this.sortASC === "ascending" ? "descending" : "ascending";
      } else {
        this.sortASC = "descending";
      }
      this.Sorting = str;
      this.handleCurrentChange(1);
    },
    GetListByType(id) {
      this.SGL_PG_CMasterSort = id;
      this.handleCurrentChange(1);
    },
    pageRemeber() {
      this.historyPushState(
        this.setUrlPar({
          currentPage: this.pageParams.currentPage,
          SGL_PG_CMasterSort: this.SGL_PG_CMasterSort,
          currentSize: this.pageParams.limit,
          Sorting: this.Sorting,
          sortASC: this.sortASC,
        })
      );
      window.scrollTo(0, 0);
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getAlbumList();
      this.pageRemeber();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getAlbumList();
      this.pageRemeber();
    },
  },
  components: {
    pagination,
    N3Vue,
  },
  computed: {
    getPageShow() {
      return this.pageParams.pageshow;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Album/albumList.vue